import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-xbrlrenderservice-modal',
  templateUrl: './xbrlrenderservice-modal.component.html'
})
export class XbrlrenderserviceModalComponent {
  @Input('XbrlRenderService') xbrlRenderService!: string;
  @Input('environment') environment!: any;
  @Output('UpdateOrganisationSettings') updateOrganisationSettings: EventEmitter<any> = new EventEmitter<any>();

  constructor(private activeModal: NgbActiveModal) { 
    // Must not be empty. It's approved by a comment.
  }

  save(){
    this.updateOrganisationSettings.emit([{key:'xbrlRenderClient', value:this.xbrlRenderService}]);
  }

  updateValue(value: string): void {
    this.xbrlRenderService = value;
  }

  closeDialog() {
    this.activeModal.close(false);
  }
}
